export default "__VITE_ASSET__qB1bigxZ__"